import { render, staticRenderFns } from "./lotes.vue?vue&type=template&id=33d753c0&"
import script from "./lotes.vue?vue&type=script&lang=js&"
export * from "./lotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports